import { FC, useEffect, useState } from 'react';
import { Checkbox } from 'antd';
import { capitalCase } from 'change-case';
import { TbArrowUpRight, TbInfoCircle } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { useEntitlements } from '@/hooks/useEntitlements';
import { PlanTag } from '@/shared';
import { PlatformAlert } from '@/shared/components/alerts';

interface WebsiteTrafficProps {
    filters: any;
    handleChange: any;
}

const WebsiteTraffic: FC<WebsiteTrafficProps> = ({ filters, handleChange }): JSX.Element => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(false);
    }, []);

    const { hasMinimumPlan } = useEntitlements();
    const { token } = useAntDesignTheme();

    const ranksArray = ['very_high', 'high', 'medium', 'medium_low', 'low', 'very_low'];

    return !hasMinimumPlan('plus') ? (
        <div style={{ textAlign: 'center', margin: '2rem' }}>
            <PlanTag plan={'plus'} style={{ marginLeft: '0.5rem' }} />
        </div>
    ) : (
        <>
            <PlatformAlert
                title='Website traffic estimates'
                showIcon
                status='info'
                icon={
                    <TbInfoCircle
                        size='1.125rem'
                        style={{
                            marginRight: '0.75rem',
                            marginTop: '0.1rem',
                        }}
                    />
                }
                description={
                    <span>
                        Based on{' '}
                        <a
                            href='https://help.clearbit.com/hc/en-us/articles/10902180076311-Clearbit-Traffic-Rank'
                            target='_blank'
                            rel='noopener noreferrer'
                        >
                            Clearbit Traffic Rank
                            <TbArrowUpRight style={{ verticalAlign: '-0.15rem', marginLeft: '0.125rem' }} />
                        </a>
                    </span>
                }
                style={{ marginBottom: '0.75rem' }}
            />
            <div style={{ marginBottom: '0.5rem' }}>
                <small style={{ color: token.colorTextTertiary }}>Rankings</small>
            </div>
            <Checkbox.Group
                value={filters?.webTraffic}
                onChange={(checkedValues) => {
                    handleChange(['webTraffic'], checkedValues);
                }}
            >
                {ranksArray?.map((r: any) => {
                    return (
                        <div key={r} style={{ width: '100%' }}>
                            <Checkbox value={capitalCase(r)} />
                            <span style={{ marginLeft: '0.5rem' }}>{r && capitalCase(r)}</span>
                        </div>
                    );
                })}
            </Checkbox.Group>
        </>
    );
};

export default WebsiteTraffic;
